export const GENERATE_CONTENT = 'GENERATE_CONTENT'
export const TEXT_REVISE = 'TEXT_REVISE'
export const TEXT_RATING = 'TEXT_RATING'
export const GENERATE_IMAGE = 'GENERATE_IMAGE'
export const TEXT_SUMMARIZE = 'TEXT_SUMMARIZE'

export const keyGenerateContent = {
  contentLength: 'contentLength',
  messageTone: 'messageTone',
  improveWriting: 'improveWriting',
}

export const keyGenerateImage = {
  imageStyle: 'imageStyle',
  imageRatio: 'imageRatio',
}

export const contentLengthOptions = {
  short: 'short.label',
  medium: 'medium.label',
  long: 'long.label',
}

export const messageToneOptions = {
  formal: 'formal.label',
  casual: 'casual.label',
  neutral: 'neutral.label',
  urgent: 'urgent.label',
  promotional: 'promotional.label',
  inspirational: 'inspirational.label',
  humorous: 'humorous.label',
}

export const improveWritingOptions = {
  shorten: 'shorten.label',
  lengthen: 'lengthen.label',
  'enhance clarity': 'enhanceClarity.label',
  'make more engaging': 'makeMoreEngaging.label',
  'increase specificity': 'increaseSpecificity.label',
  generalize: 'generalize.label',
  'optimize for seo': 'optimizeForSeo.label',
}

export const imageStyleOptions = {
  realistic: 'realistic.label',
  minimalist: 'minimalist.label',
  'corporate illustration': 'corporateIllustration.label',
  infographic: 'infographic.label',
  abstract: 'abstract.label',
  elegant: 'elegant.label',
}

export const imageRatioOptions = {
  square: 'square.label',
  portrait: 'portrait.label',
  landscape: 'landscape.label',
}
